import React from 'react'

function AddCustomerModal({ isOpen, onClose, onSelectType }) {
  if (!isOpen) return null

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '40px',
        width: '90%',
        maxWidth: '500px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: 'bold',
          marginBottom: '10px',
          color: '#0d47a1'
        }}>
          Add New Customer
        </h2>

        <p style={{
          fontSize: '14px',
          color: '#666',
          marginBottom: '30px'
        }}>
          Select customer type to begin onboarding process
        </p>

        <div style={{
          display: 'flex',
          gap: '20px',
          marginBottom: '20px'
        }}>
          {/* Individual Button */}
          <button
            onClick={() => onSelectType('individual')}
            style={{
              flex: 1,
              padding: '20px',
              border: '2px solid #0d47a1',
              backgroundColor: '#f5f5f5',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#0d47a1'
            }}
          >
            👤 Individual KYC
          </button>

          {/* Corporate Button */}
          <button
            onClick={() => onSelectType('corporate')}
            style={{
              flex: 1,
              padding: '20px',
              border: '2px solid #0d47a1',
              backgroundColor: '#f5f5f5',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#0d47a1'
            }}
          >
            🏢 Corporate KYB
          </button>
        </div>

        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  )
}

export default AddCustomerModal